import { FC } from 'react'

import { LogoProps } from '@assets/logo/types'

export const TMPartnersLogo: FC<LogoProps> = ({ className }) => (
  <svg
    className={className}
    width='157'
    height='32'
    id='Layer_1'
    data-name='Layer 1'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 157 32'
  >
    <defs>
      <style>
        {`
          .cls-1 { fill: #f04; }
          .cls-2 { fill: var(--text-white) }
          .cls-3 { fill: #28f981; }
        `}
      </style>
    </defs>
    <g>
      <path
        className='cls-1'
        d='M17.513461,21.048798h-5.04598c-.612508,0-1.178534-.326759-1.484788-.857246l-2.899548-5.022158c-.306254-.530459-.306254-1.184033,0-1.71452l2.899548-5.022131c.306254-.530487.87228-.857274,1.484788-.857274h5.043438L21.517868.635228c-.085504-.006328-.170178-.017051-.256787-.017051h-11.788103c-1.245135,0-2.395647.664269-3.018214,1.742598L.560713,12.569549c-.622512,1.078301-.622512,2.406867,0,3.485167l5.894051,10.208774c.622567,1.078328,1.773079,1.74257,3.018214,1.74257h11.788103c.087383,0,.172886-.01075.259164-.017217l-4.006783-6.940047Z'
      />
      <path
        className='cls-3'
        d='M30.173346,12.569549l-5.894051-10.208774c-.043774-.075831-.095894-.144643-.144754-.216274l-4.006838,6.940019,2.523266,4.370353c.306199.530487.306199,1.184061,0,1.71452l-2.521995,4.368197,4.006894,6.940157c.048306-.071023.10004-.139144.143427-.214256l5.894051-10.208774c.622567-1.078301.622567-2.406867,0-3.485167Z'
      />
    </g>
    <g>
      <polygon
        className='cls-2'
        points='36.090444 8.486068 41.424416 8.486068 41.424416 22.659402 45.380555 22.659402 45.380555 8.486068 50.738899 8.486068 50.738899 5.130866 36.090444 5.130866 36.090444 8.486068'
      />
      <rect className='cls-2' x='53.344253' y='5.130866' width='3.956139' height='17.528536' />
      <path
        className='cls-2'
        d='M69.795455,19.328572c-.885997,0-1.661555-.154078-2.329229-.462296-.667734-.309433-1.22503-.726752-1.671827-1.253232-.446858-.525143-.780725-1.11836-1.001601-1.777099-.220815-.660015-.331253-1.339237-.331253-2.041615,0-1.635906.517424-2.958489,1.552394-3.967748,1.03497-1.010536,2.294584-1.515135,3.781517-1.515135,1.635906,0,3.154931.767839,4.557075,2.303579l2.30364-2.83006c-2.003141-1.953058-4.306721-2.930226-6.910798-2.930226-2.672091,0-4.896048.864177-6.674484,2.59253-1.777099,1.727016-2.665648,3.859863-2.665648,6.397143,0,2.605293.871835,4.771509,2.615565,6.498525,1.745068,1.728353,3.935656,2.59253,6.574379,2.59253,2.53728,0,4.898601-1.052961,7.08536-3.156207l-2.328013-2.528285c-1.468942,1.38549-2.987967,2.077598-4.557075,2.077598Z'
      />
      <polygon
        className='cls-2'
        points='95.337773 5.130866 90.729338 5.130866 83.468019 13.293559 83.468019 5.130866 79.51188 5.130866 79.51188 22.659402 83.468019 22.659402 83.468019 18.252515 85.97193 15.472599 91.029776 22.659402 95.762811 22.659402 88.726197 12.417834 95.337773 5.130866'
      />
      <polygon
        className='cls-2'
        points='101.998156 10.815297 107.005918 20.880966 109.559913 20.880966 114.543303 10.815297 114.543303 22.659402 118.098838 22.659402 118.098838 5.130866 113.716385 5.130866 108.307957 15.898852 102.849447 5.130866 98.442621 5.130866 98.442621 22.659402 101.998156 22.659402 101.998156 10.815297'
      />
      <rect className='cls-2' x='122.456918' y='5.130866' width='3.956139' height='17.528536' />
      <polygon
        className='cls-2'
        points='142.237674 19.204033 134.726 19.204033 134.726 5.130866 130.7698 5.130866 130.7698 22.659402 142.237674 22.659402 142.237674 19.204033'
      />
      <polygon
        className='cls-2'
        points='156.536823 19.204033 149.025149 19.204033 149.025149 5.130866 145.06901 5.130866 145.06901 22.659402 156.536823 22.659402 156.536823 19.204033'
      />
      <g>
        <path
          className='cls-2'
          d='M110.275119,31.523095h-1.303711v-5.775391h2.451172c.527344,0,.961914.083984,1.302734.251953s.594727.402344.759766.703125.24707.651367.24707,1.049805c0,.393555-.078125.75-.233398,1.070312s-.40625.578125-.75293.773438c-.337891.18457-.779297.276367-1.323242.276367h-1.147461v1.650391ZM111.356173,28.783837c.758789,0,1.138672-.330078,1.138672-.990234,0-.643555-.379883-.964844-1.138672-.964844h-1.081055v1.955078h1.081055Z'
        />
        <path
          className='cls-2'
          d='M120.225314,31.523095h-1.394531l-.454102-1.12207h-2.672852l-.453125,1.12207h-1.344727l2.507812-5.775391h1.344727l2.466797,5.775391ZM117.956759,29.353173l-.908203-2.244141-.915039,2.244141h1.823242Z'
        />
        <path
          className='cls-2'
          d='M126.2634,31.523095h-1.476562l-.916016-1.650391h-1.328125v1.650391h-1.303711v-5.775391h2.508789c.439453,0,.838867.066406,1.198242.200195.358398.133789.646484.351562.864258.654297.203125.293945.304688.677734.304688,1.150391,0,.885742-.360352,1.506836-1.080078,1.864258l1.228516,1.90625ZM123.747775,28.783837c.75293,0,1.129883-.330078,1.129883-.990234,0-.643555-.376953-.964844-1.129883-.964844h-1.205078v1.955078h1.205078Z'
        />
        <path
          className='cls-2'
          d='M130.116916,31.523095h-1.303711v-4.669922h-1.756836v-1.105469h4.826172v1.105469h-1.765625v4.669922Z'
        />
        <path
          className='cls-2'
          d='M138.227267,31.523095h-1.188477l-2.796875-3.712891v3.712891h-1.246094v-5.775391h1.188477l2.804688,3.729492v-3.729492h1.238281v5.775391Z'
        />
        <path
          className='cls-2'
          d='M144.397189,31.523095h-4.488281v-5.775391h4.397461v1.081055h-3.09375v1.253906h2.780273v1.081055h-2.780273v1.27832h3.18457v1.081055Z'
        />
        <path
          className='cls-2'
          d='M150.85715,31.523095h-1.476562l-.916016-1.650391h-1.328125v1.650391h-1.303711v-5.775391h2.508789c.439453,0,.838867.066406,1.198242.200195.358398.133789.646484.351562.864258.654297.203125.293945.304688.677734.304688,1.150391,0,.885742-.360352,1.506836-1.080078,1.864258l1.228516,1.90625ZM148.341525,28.783837c.75293,0,1.129883-.330078,1.129883-.990234,0-.643555-.376953-.964844-1.129883-.964844h-1.205078v1.955078h1.205078Z'
        />
        <path
          className='cls-2'
          d='M154.296603,31.613915c-.945312,0-1.795898-.308594-2.548828-.923828l.519531-1.064453c.396484.307617.770508.530273,1.12207.667969.352539.137695.660156.206055.923828.206055.572266,0,.858398-.192383.858398-.577148,0-.208984-.098633-.373047-.296875-.491211s-.495117-.223633-.891602-.317383c-.577148-.175781-.972656-.327148-1.1875-.454102-.467773-.286133-.701172-.711914-.701172-1.27832,0-.555664.213867-.981445.643555-1.279297.428711-.296875.958984-.445312,1.591797-.445312.808594,0,1.540039.211914,2.194336.635742l-.50293,1.080078c-.704102-.395508-1.303711-.59375-1.798828-.59375-.483398,0-.728516.162109-.734375.487305,0,.186523.095703.342773.285156.467773s.482422.236328.878906.332031l.362305.111328c.080078.024414.227539.080078.441406.165039.34082.137695.610352.325195.806641.563477.196289.237305.294922.554688.294922.950195,0,.561523-.208984.994141-.626953,1.299805-.417969.304688-.962891.458008-1.633789.458008Z'
        />
      </g>
    </g>
  </svg>
)
